import {BaseModel} from "../../../../infrastructure/models/base-model";
import type {ImageRequestParams} from "../../../../infrastructure/models/params/image-request-params";
import {computed} from 'mobx';
import {
  EntityContainerHashParamsModel
} from "../../../../core/components/router/models/entity-container-hash-params-model";

export class NavigationTabsModuleTabModel extends BaseModel {
  index: Number;
  name: String;

  constructor(index: Number, name: String, currentIndex: Number) {
    super();

    this.index = index;
    this.name = name;
    this.currentIndex = currentIndex;
  }

  get tabName() {
    return this.name?.toLowerCase();
  }

  @computed get isVisible(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: isVisible');
  }

  @computed get isActive(): Boolean {
    const isCurrentIndex: Boolean = this.currentIndex === this.index;

    return isCurrentIndex;
  }

  get iconSource(): ImageRequestParams {
    return null;
  }

  get hasIcon(): Boolean {
    return false;
  }

  get isIconFirst(): Boolean {
    return false;
  }

  get isNoFollow(): Boolean {
    return false;
  }

  get eventName(): String {
    return console.error(this.constructor.name + 'Implementation is missing: eventName');
  }

  get eventParams(): Object {
    return console.error(this.constructor.name + 'Implementation is missing: eventParams');
  }

  get analyticsName(): Object {
    return console.error(this.constructor.name + 'Implementation is missing: analyticsName');
  }

  get analyticsEntityType(): Object {
    return console.error(this.constructor.name + 'Implementation is missing: analyticsEntityType');
  }

  get analyticsEntityId(): Object {
    return null;
  }

  get status(): Object {
    return null;
  }

  get elementId(): String {
    return 'navigation-tabs';
  }

  itemHashParams(urlFilter) {
    let hashParams = new EntityContainerHashParamsModel({[urlFilter]: urlFilter})

    return hashParams;
  }
}
